import { invoke } from '@tauri-apps/api/core';

export interface AppInfo {
  version: string;
  profile: string;
  computerName: string;
}

export interface DeviceIdentity {
  deviceId: string;
  deviceSecret: string;
}

export function getAppInfo(): Promise<AppInfo> {
  return invoke<AppInfo>('get_app_info');
}

export function identityLoad(): Promise<DeviceIdentity | null> {
  return invoke<DeviceIdentity | null>('identity_load');
}

export function identitySave(identity: DeviceIdentity): Promise<void> {
  return invoke('identity_save', { identity });
}

export function authTokenLoad(): Promise<string | null> {
  return invoke<string | null>('auth_token_load');
}

/** `null` sai da conta. */
export function authTokenSave(token: string | null): Promise<void> {
  return invoke('auth_token_save', { token });
}

export function accessPasswordEnabled(): Promise<boolean> {
  return invoke<boolean>('access_password_enabled');
}

/** `null` remove a senha. */
export function accessPasswordSet(password: string | null): Promise<void> {
  return invoke('access_password_set', { password });
}

export function accessPasswordVerify(password: string): Promise<boolean> {
  return invoke<boolean>('access_password_verify', { password });
}

export function windowBringToFront(): Promise<void> {
  return invoke('window_bring_to_front');
}

export function monitorWindowClose(title: string): Promise<void> {
  return invoke('monitor_window_close', { title });
}
